import { CreditReportAlertAndTriggers } from "types/landlord/reports";
import { Row } from "views/applications-id-report/components/Row";
import { Section } from "views/applications-id-report/components/Section";

interface AlertsAndTriggersProps {
  alerts_and_triggers?: CreditReportAlertAndTriggers;
  isNoHit: boolean;
}

export const AlertsAndTriggers = ({
  alerts_and_triggers,
  isNoHit
}: AlertsAndTriggersProps) => {
  if (isNoHit)
    return (
      <Section sectionTitle="Alerts and Triggers" maxWidth="none">
        <p className="text-base font-medium text-content-300">
          No data available
        </p>
      </Section>
    );

  return (
    <Section sectionTitle="Alerts and triggers" maxWidth="none">
      <h2 className="text-content-1000 text-sm font-bold">Summary</h2>
      <div className="border-b border-alpha-40 mt-2 mb-4" />
      <div className="flex flex-col gap-3">
        <Row
          title="Fraud victim indicator"
          value={alerts_and_triggers?.fraud_victim_indicator}
        />
        <Row
          title="Address discrepancy indicator"
          value={alerts_and_triggers?.address_discrepancy_indicator}
        />
      </div>
      <h2 className="mt-8 text-sm font-bold text-content-1000">
        Alert contact information
      </h2>
      <div className="border-b border-alpha-40 mt-2 mb-4" />
      {alerts_and_triggers?.alert_contacts?.length ? (
        alerts_and_triggers.alert_contacts.map((contact, index) => {
          return (
            <div key={`${contact.phone_numbers}_${contact.address}`}>
              <p className="text-sm font-bold text-content-1000">
                Alert {index + 1}
              </p>
              <div className="flex flex-wrap  pt-4">
                <div className="flex w-1/2 flex-col gap-3">
                  <Row
                    title="Alert type"
                    value={
                      typeof contact.type === "string"
                        ? contact.type
                        : contact.type?.description
                    }
                  />
                  <Row title="Date Reported" value={contact.date_reported} />
                  <Row title="Date Effective" value={contact.date_effective} />
                </div>
                <div className="flex w-1/2 flex-col gap-3">
                  {contact.phone_numbers?.map((phone_number, index) => {
                    return (
                      <Row
                        key={phone_number.phone_number}
                        title={`Phone ${index + 1}`}
                        value={phone_number.phone_number}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <p className="text-sm text-content-1000 font-medium">
          No data available
        </p>
      )}
    </Section>
  );
};
